import axiosService from '@/services/axios/axios.service';
import type { PayrollEntry } from '@/models/payroll.model';

export const generatePayroll = async (
  month: string,
  requiredWorkingDays?: number,
  signal?: AbortSignal
): Promise<{ month: string; count: number }> => {
  const response = await axiosService.post(
    '/payroll/generate',
    { month, requiredWorkingDays },
    { 
      timeout: 600000, // 10 minutes timeout for large datasets
      signal, // Support request cancellation
    }
  );
  return response.data;
};

export const getPayrollByMonth = async (month: string): Promise<PayrollEntry[]> => {
  const response = await axiosService.get('/payroll', { params: { month } });
  return response.data;
};

export const updatePayrollEntry = async (id: string, payload: Partial<PayrollEntry>): Promise<PayrollEntry> => {
  const response = await axiosService.patch(`/payroll/${id}`, payload);
  return response.data;
};

export const sendPayrollEmails = async (month: string): Promise<{ month: string; count: number }> => {
  const response = await axiosService.post('/payroll/send-emails', { month }, { timeout: 60000 });
  return response.data;
};

export const sendPayrollTestEmails = async (
  month: string,
  email: string
): Promise<{ month: string; count: number }> => {
  const response = await axiosService.post('/payroll/send-test-emails', { month, email }, { timeout: 60000 });
  return response.data;
};

export const sendPayrollEmail = async (id: string): Promise<{ success: boolean; entry: PayrollEntry }> => {
  const response = await axiosService.post(`/payroll/${id}/send`);
  return response.data;
};

export const sendPayrollTestEmail = async (id: string, email: string): Promise<{ success: boolean; entry: PayrollEntry }> => {
  const response = await axiosService.post(`/payroll/${id}/send-test`, { email });
  return response.data;
};


